// 녹음 코덱/브라우저 호환 유틸 (PORTAL-12590)
// - MediaRecorder 지원 여부와 지원 포맷을 감지한다.
// - 파일 확장자를 "무조건 .webm"으로 고정하지 않고 실제 녹음 포맷에 맞춘다.
//   (Safari/iOS 는 webm 을 지원하지 않아 audio/mp4 로 녹음되므로,
//    .webm 확장자로 저장하면 재생 불가 파일이 될 수 있다.)

// 녹음에 사용할 MIME 타입 우선순위. 앞에서부터 isTypeSupported 로 검사해 첫 지원값을 사용.
const PREFERRED_MIME_TYPES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4;codecs=mp4a.40.2',
  'audio/mp4',
  'audio/ogg;codecs=opus',
  'audio/ogg',
  'audio/mpeg',
];

// MIME 타입(코덱 파라미터 제외) → 파일 확장자(점 없음)
const MIME_EXTENSION_MAP: Record<string, string> = {
  'audio/webm': 'webm',
  'audio/ogg': 'ogg',
  'audio/mp4': 'm4a',
  'audio/mpeg': 'mp3',
  'audio/aac': 'aac',
  'audio/wav': 'wav',
  'audio/x-wav': 'wav',
};

const DEFAULT_EXTENSION = 'webm';

// 브라우저가 녹음(MediaRecorder + getUserMedia)을 지원하는지 여부
export const isRecordingSupported = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    typeof window.MediaRecorder !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    !!navigator.mediaDevices &&
    typeof navigator.mediaDevices.getUserMedia === 'function'
  );
};

// 현재 브라우저가 지원하는 녹음 MIME 타입(우선순위 첫 지원값). 없으면 '' 반환.
// react-voice-visualizer 가 mimeType 을 지정하지 않고 MediaRecorder 를 생성하므로
// 직접 주입할 수는 없으나, 확장자 결정과 지원 여부 판단에 사용한다.
export const getSupportedRecordingMimeType = (): string => {
  if (!isRecordingSupported()) return '';
  if (typeof window.MediaRecorder.isTypeSupported !== 'function') return '';
  return (
    PREFERRED_MIME_TYPES.find((type) =>
      window.MediaRecorder.isTypeSupported(type),
    ) ?? ''
  );
};

// MIME 타입 → 파일 확장자(점 없음). 알 수 없으면 webm 으로 폴백.
export const getAudioExtensionFromMimeType = (mimeType?: string): string => {
  if (!mimeType) return DEFAULT_EXTENSION;
  const base = mimeType.split(';')[0].trim().toLowerCase();
  return MIME_EXTENSION_MAP[base] ?? DEFAULT_EXTENSION;
};

// 파일명의 확장자를 주어진 확장자로 교체 (없으면 붙임)
export const withAudioExtension = (
  fileName: string,
  extension: string,
): string => {
  const dotIndex = fileName.lastIndexOf('.');
  const base = dotIndex === -1 ? fileName : fileName.slice(0, dotIndex);
  return `${base}.${extension}`;
};
